import $ from "jquery";
import { getFilledTemplate } from "./ServiceFunctions";

class FileService {
  /**
   * upload field record uid
   *
   * @property uid
   * @type {string}
   */
  uid = "";

  /**
   * contains ajax url
   *
   * @property url
   * @type {string}
   */
  requestUrl = "";

  /**
   * prefix for plugin parameters
   *
   * @property pluginPrefix
   * @type {string}
   */
  pluginPrefix = "tx_jhforms_ajax";

  /**
   * contains dispatch path segment
   *
   * @property dispatcher
   * @type {string}
   */
  dispatcherPathSegment = `${window.location.pathname}?type=1681301068`;

  /**
   *  Template container (identifier)
   *  defined in /Partials/Registrations/Fields.html
   *
   *  @property successTemplate
   *  @type {String}
   */
  successTemplate = ".file-placeholder";

  /**
   *  Template container (identifier)
   *  defined in /Partials/Registrations/Fields.html
   *
   *  @property successTemplate
   *  @type {String}
   */
  errorTemplate = ".file-upload-error";

  /**
   * upload button identifier
   *
   * @property uploadIdentifier
   * @type {string}
   */
  uploadIdentifier = ".js-file-upload";

  /**
   * upload button identifier
   *
   * @property uploadIdentifier
   * @type {string}
   */
  formSubmitButton = ".js-contact-form-submit";

  /**
   * contains temporary file data
   *
   * @property uploadData
   * @type {Array}
   */
  uploadData = [];

  formUploadErrors = {};

  /**
   * initialize file upload button
   *
   * @method initFileService
   * @param $dom
   */
  initFileService($dom) {
    const uploadField = $dom.find(this.uploadIdentifier);
    uploadField.change((tmpData) => {
      this.uploadProcessor($dom, uploadField, tmpData);
    });

    let formUploadErrors = $(".contact-form").data("form-upload-errors") || {};
    if (typeof formUploadErrors === "string") {
      formUploadErrors = JSON.parse(formUploadErrors);
    }
    this.formUploadErrors = formUploadErrors;
  }

  /**
   * delete file handling
   *
   * @method deleteProcessor
   * @param $dom
   * @param that
   */
  deleteProcessor($dom, that) {
    const file = $(that).attr("data-file");
    this.deleteFile($dom, file);
    $dom.find(".js-file-placeholder").remove();
    $dom.find(this.uploadIdentifier).show().val("");
    $dom.find(".js-file-hidden").val("");
  }

  /**
   * file upload handling
   *
   * @method uploadProcessor
   * @param $dom
   * @param that
   * @param tmpData
   * @return {Object}
   */
  uploadProcessor($dom, that, tmpData) {
    // activate overlay
    $dom.find(".page-overlay").addClass("active");
    // set upload file array
    this.uploadData = tmpData;
    this.uid = $(that).attr("data-uid");

    // upload file and get response success or error
    this.uploadFile(this.getFileUploadData())
      .done((response) => {
        const responseText = JSON.parse(response);
        // error check
        if (Object.prototype.hasOwnProperty.call(responseText, "file")) {
          this.showSuccessWidget($dom, responseText.file, that);
        } else {
          let error;

          if (
            Object.prototype.hasOwnProperty.call(
              this.formUploadErrors,
              responseText.e
            )
          ) {
            error = this.formUploadErrors[responseText.e];
          } else {
            error = `Error: File could not be uploaded: Code ${responseText.e}`;
          }
          this.showErrorWidget($dom, error, that);
        }
        $(that).hide();
      })
      .fail(() => {
        this.showErrorWidget($dom, "Error: Communication failed", that);
      });
  }

  /**
   * show upload success widget
   *
   * @method showSuccessWidget
   * @param $dom
   * @param filename {string}
   * @param that {object}
   */
  showSuccessWidget($dom, filename, that) {
    const $placeholder = getFilledTemplate(this.successTemplate, {
      "###filename###": filename,
    });
    $placeholder.insertAfter(that);
    $dom.find(".js-file-hidden").val(filename);
    this.enableForm();
    $placeholder.find(".js-remove-file").click((e) => {
      this.deleteProcessor($dom, e.currentTarget);
    });
  }

  /**
   * show upload error widget
   *
   * @method showErrorWidget
   * @param $dom
   * @param message {string}
   * @param that {object}
   */
  showErrorWidget($dom, message, that) {
    const $placeholder = getFilledTemplate(this.errorTemplate, {
      "###error###": message,
    });
    $placeholder.insertAfter(that);
    $placeholder.find(".js-remove-error").click(() => {
      $dom.find(".js-file-error").remove();
      $dom.find(this.uploadIdentifier).show().val("");
      this.enableForm();
    });
    this.disableForm();
  }

  /**
   * disable form submit button
   *
   * @method disableForm
   */
  disableForm() {
    $(this.formSubmitButton).attr("disabled", "disabled");
  }

  /**
   * enable form submit button
   *
   * @method enableForm
   */
  enableForm() {
    $(this.formSubmitButton).removeAttr("disabled");
  }

  /**
   * file upload processor
   *
   * @method fileUploadProcessor
   * @return {Array}
   */
  getFileUploadData() {
    // get current file data array
    const file = this.uploadData.target.files[0];

    // Stop stuff happening
    this.uploadData.stopPropagation();

    // Totally stop stuff happening
    this.uploadData.preventDefault();

    // build new form with file data array
    const data = new FormData();
    data.append("file", file);

    return data;
  }

  /**
   * calls the ajax file upload action
   *
   * @method uploadFile
   * @param data {object}
   */
  uploadFile(data) {
    this.generateAjaxUrl({ action: "uploadFile", uid: this.uid });
    return $.ajax({
      url: this.requestUrl,
      type: "post",
      dataType: "text", // what to expect back from the PHP script, if anything
      async: true,
      cache: false,
      contentType: false,
      processData: false,
      data,
      success: (dataResponse) => {
        $(".page-overlay.active").removeClass("active");
        return dataResponse;
      },
      error: (response) => {
        $(".page-overlay.active").removeClass("active");
        return response;
      },
    });
  }

  /**
   * calls the ajax delete file action
   *
   * @method deleteFile
   * @param file {string}
   */
  deleteFile($dom, file) {
    $dom.find(".page-overlay").addClass("active");
    this.generateAjaxUrl({ action: "deleteFile", file });

    return $.ajax({
      url: this.requestUrl,
      type: "post",
      dataType: "text", // what to expect back from the PHP script, if anything
      async: true,
      cache: false,
      contentType: false,
      processData: false,
      success: (dataResponse) => {
        $(".page-overlay.active").removeClass("active");
        return dataResponse;
      },
      error: (response) => {
        $(".page-overlay.active").removeClass("active");
        return response;
      },
    });
  }

  /**
   * generate and set ajax request url
   * id is set in Private/TypoScript/HeidehhainFormsAjaxConfiguration.ts
   *
   * @method generateAjaxUrl
   * @param parameters
   */
  generateAjaxUrl(parameters) {
    // url initial set
    this.requestUrl = this.dispatcherPathSegment;

    Object.keys(parameters).forEach((property) => {
      this.requestUrl += `&${this.pluginPrefix}[${property}]=${parameters[property]}`;
    });
  }
}

export default FileService;
